export default __webpack_public_path__ + "static/media/box-eterxperience.ea39f333.jpeg";